"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankSubjectOptionEnum = void 0;
var BankSubjectOptionEnum;
(function (BankSubjectOptionEnum) {
    BankSubjectOptionEnum["INVOICE_NUMBER"] = "invoice_number";
    BankSubjectOptionEnum["EXPENSE_NUMBER"] = "expense_number";
    BankSubjectOptionEnum["VENDOR_NAME"] = "vendor_name";
    BankSubjectOptionEnum["DESCRIPTION"] = "description";
    BankSubjectOptionEnum["REQUEST_ITEMS"] = "request_items";
})(BankSubjectOptionEnum = exports.BankSubjectOptionEnum || (exports.BankSubjectOptionEnum = {}));
